import { getLocale } from "../runtime";

const sv_loadmore = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ladda mer`
};

const loadmore = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_loadmore(inputs)
	return "loadMore";
};

export { loadmore as "loadMore" };